import { render, staticRenderFns } from "./investment-level-panel.vue?vue&type=template&id=65d7f8ae&scoped=true&"
import script from "./investment-level-panel.vue?vue&type=script&lang=ts&"
export * from "./investment-level-panel.vue?vue&type=script&lang=ts&"
import style0 from "./investment-level-panel.vue?vue&type=style&index=0&id=65d7f8ae&lang=scss&scoped=true&"
import style1 from "./investment-level-panel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7f8ae",
  null
  
)

export default component.exports